import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";
import {myAcademy} from "@/lib/services/academyService";

export const useApiSearchAdminRoles = (config) => {
    return useQuery({
        queryKey: ['admin', 'roles', 'search', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/roles`, {params: config})
        })(config)),
    })
}


export const useApiSearchAdminPermissions = (config) => {
    return useQuery({
        queryKey: ['admin', 'permission', 'search', config, myAcademy()],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/permissions`, config)
        })(config)),
    })
}


export function useApiUpdateAdminMemberRole() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data) => {
                return generalRequest.put(`/admin/members/${data?.id}/permission`, data?.args)
            })(data))
    });

}


export function useApiUpdateAdminRolePermissions() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.put(`/admin/roles/${data?.id}/permissions`, data?.data)
            })(data))
    });

}


export function useApiCreateAdminRole() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/roles`, data)
            })(data))
    });

}


export function useApiUpdateAdminRole() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.put(`/admin/roles/${data?.id}`, data?.args)
            })(data))
    });

}


export function useApiDeleteAdminRole() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.delete(`/admin/roles/${data?.id}`)
            })(data))
    });

}


export const useApiReadAdminRole = (config) => {
    return useQuery({
        queryKey: ['admin', 'roles', 'get', config, myAcademy()],
        queryFn: () => ((async (id = {}) => {
            return generalRequest.get(`/admin/roles/${id}`)
        })(config)),
    })
}
